import React from "react";
import { useController } from "react-hook-form";
import { MultiselectBubble } from "../../../../../../../Inputs/MultiselectBubble";
import {
  getSchemaPropertyFormPath,
  getUiSchemaPropertyFormPath,
  useBuilderWatch,
} from "../../../form/form";
import type { InputSettingsFormProps } from "../FieldSettingsView";

export function TagsStaticDefaultInput({
  fieldPath,
  isReadOnly,
}: Pick<InputSettingsFormProps, "fieldPath" | "isReadOnly">) {
  const defaultValuePath = getUiSchemaPropertyFormPath(
    fieldPath,
    "defaultValue",
  );

  const { field } = useController({ name: defaultValuePath });

  const options = useBuilderWatch(
    getSchemaPropertyFormPath(fieldPath, "items.enum"),
  ) as Array<string>;

  // ensure empty strings don't show up
  const nonEmptyItems = options.map(option => option.trim()).filter(Boolean);

  return (
    <MultiselectBubble
      items={nonEmptyItems}
      selectedItems={field.value}
      onChange={(value: Maybe<Array<string>>) => {
        // store no value (undefined) for ui:defaultValue instead of empty
        // string in form state
        field.onChange(value?.length ? value : undefined);
      }}
      name={defaultValuePath}
      label="Static default value"
      disabled={isReadOnly}
      readonly={isReadOnly}
    />
  );
}
